var r=(r,e,s="asc")=>{const t=Array.from({length:e-r+1},(e,s)=>r+s);return"desc"===s?t.reverse():t};export{r as getYearOptions};
//# sourceMappingURL=getYearOptions.js.map